@use "~theme/breakpoints";
.container {
    max-width: 100%;
    width: 100%;
    background: #FFFFFF;    
    box-shadow: 0px 2px 6px #eaeaea;
    border-radius: 4px;
    overflow:auto;
    padding: 10px;
    border: none;
    border-bottom: 1px solid var(--blue-01-at-30);
    @include breakpoints.desktop {
        border: 1px solid #40668C; 
        border-radius: 0px 0px 4px 4px;       
    }
}

.title {
    font-weight: bold;
    font-size: 16px;
}

.list {
    color: #003366;
    font-size: 14px;
}

.listTrophy {
    color: #003366;
    font-size: 14px;
}

.icon {
    padding-right: 5px;
}

.iconTrophy {
    padding-right: 5px;
}